import { render } from "./SimilarProjects.vue?vue&type=template&id=7fa03394&scoped=true"
import script from "./SimilarProjects.vue?vue&type=script&lang=js"
export * from "./SimilarProjects.vue?vue&type=script&lang=js"

import "./SimilarProjects.vue?vue&type=style&index=0&id=7fa03394&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa03394"]])

export default __exports__